import React from 'react';
import EventLog from './LogItem';

const ObjectiveLog = ({ event }) => {
  const details = {
    itemType: 'objective',
    actualItem: event?.objective,
    previousItem: event?.oldObjective,
    ...event
  };

  return (
    <EventLog event={ details }/>
  );
};

export default ObjectiveLog;
